import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useCallback, useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Modal from '../Modal/Modal.js';
import SuccessoIcon from '../Icons/SuccessoIcon.js';
import ErroreIcon from '../Icons/ErroreIcon.js';
import InfoIcon from '../Icons/InfoesIcon.js';
import { createModalPromise } from '../Utils/modals.js';
import ConfirmButton from './FooterButton.js';

var ConfirmType;
(function (ConfirmType) {
    ConfirmType["info"] = "info";
    ConfirmType["error"] = "error";
    ConfirmType["warning"] = "warning";
    ConfirmType["success"] = "success";
})(ConfirmType || (ConfirmType = {}));
function executeCallback(callback, setWorkingState, close) {
    if (callback) {
        const res = callback();
        if (res && res.then) {
            setWorkingState(true);
            res.then(() => {
                setWorkingState(false);
                close === null || close === void 0 ? void 0 : close();
            });
            return;
        }
    }
    close === null || close === void 0 ? void 0 : close();
}
function Confirm({ className, message, type, confirmPrimary, testoConferma, confirmText, cancelText, title, onConfirm, onCancel, show, onClose, dontShowAgainId, }) {
    const [working, setWorking] = useState(false);
    const renderIcon = useCallback(() => {
        if (type === 'success') {
            return jsx(SuccessoIcon, {});
        }
        if (type === 'error' || type === 'warning') {
            return jsx(ErroreIcon, {});
        }
        if (type === 'info') {
            return jsx(InfoIcon, {});
        }
        return null;
    }, [type]);
    const annulla = useCallback(() => {
        executeCallback(onCancel, setWorking, onClose);
    }, [onClose, onCancel]);
    const conferma = useCallback(() => {
        executeCallback(onConfirm, setWorking, onClose);
    }, [onClose, onConfirm]);
    const classes = useMemo(() => cns('confirm', {
        'confirm--success': type === 'success',
        'confirm--error': type === 'error',
        'confirm--warning': type === 'warning',
        'confirm--info': type === 'info',
    }, className), [className, type]);
    return (jsxs(Modal, { className: classes, doNotFocus: true, onClose: onClose, show: show, dontShowAgainId: dontShowAgainId, children: [jsxs(Modal.Header, { children: [jsx("div", { className: "confirm__icon", children: renderIcon() }), jsx("div", { className: "confirm__title", children: title })] }), jsx(Modal.Body, { children: message }), jsxs(Modal.Footer, { children: [jsx(ConfirmButton, { onClick: annulla, text: cancelText || 'Annulla', disabled: working, primary: !confirmPrimary }), jsx(ConfirmButton, { onClick: conferma, text: confirmText || testoConferma || 'Conferma', disabled: working, loading: working, primary: confirmPrimary })] })] }));
}
Confirm.defaultProps = {
    className: '',
    testoConferma: undefined,
    cancelText: undefined,
    confirmText: undefined,
    type: ConfirmType.info,
    show: true,
    onClose: undefined,
    onCancel: undefined,
    onConfirm: undefined,
    confirmPrimary: true,
    dontShowAgainId: undefined,
};
Confirm.createModalPromise = (props) => createModalPromise(Confirm, props, 'temp-modal-confirm');

export { ConfirmType, Confirm as default };
